// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { useRef, Children } from 'react';
import classNames from 'classnames';
import { useResizeObserver } from '../../hooks';
import Icon from '../Icon';
import Tab from './Tab';
import TabListItem from './TabListItem';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FakeTabs = _ref => {
  let {
    children,
    onResize,
    baseClassName
  } = _ref;
  const tabsRef = useRef(null);
  useResizeObserver({
    ref: tabsRef,
    onResize
  });
  const list = /*#__PURE__*/_jsxs("ul", {
    ref: tabsRef,
    className: classNames(`${baseClassName}__tab-list`, `${baseClassName}__tab-list--fake`),
    children: [Children.map(children, (tab, index) => {
      if (!tab || tab.type !== Tab) {
        return null;
      }
      return /*#__PURE__*/_jsx(TabListItem, {
        // eslint-disable-line react/no-array-index-key
        tab: tab,
        baseClassName: baseClassName,
        isFake: true
      }, index);
    }), /*#__PURE__*/_jsx("li", {
      className: classNames(`${baseClassName}__tab`, `${baseClassName}__tab--more`),
      children: /*#__PURE__*/_jsx("a", {
        className: `${baseClassName}__link`,
        tabIndex: -1,
        children: /*#__PURE__*/_jsx(Icon, {
          name: "three-dots-horizontal"
        })
      })
    })]
  });
  return /*#__PURE__*/_jsx("div", {
    className: `${baseClassName}__fake-list-wrapper`,
    "aria-hidden": true,
    children: list
  });
};
export default FakeTabs;